export default __webpack_public_path__ + "images/CT.6628cd9.png";